import {LocalityResponsePayload} from './../../../shared/models/api/localityResponsePayload';
import {storage, StorageKeys} from './../../../shared/storage/index';
import {localitiesSlice} from './../../reducers/localities/index';
import {HttpWrapperOptions} from './../../../shared/httpWrapper/options';
import {apiUrls} from './../../../shared/constants/urls';
import {getApiRoute} from './../../../shared/pipes/getApiRoute';
import {AppThunk} from './../index';
import {httpService} from '../../../shared/httpWrapper';

export const getLocalities = (): AppThunk => {
  return async (dispatch) => {
    const list = await httpService.get(
      getApiRoute(apiUrls.getLocalitiesList),
      new HttpWrapperOptions().Wait(false).Errors(true).ThrowException(false).TrackRequest(),
    );
    if (list) {
      dispatch(localitiesSlice.actions.setLocalities(list));
    }
  };
};

export const setCurrentLocality = (locality: LocalityResponsePayload): AppThunk => {
  return async (dispatch) => {
    await storage.setItem(StorageKeys.locality, locality);
    dispatch(localitiesSlice.actions.setCurrentLocality(locality));
  };
};
